// create/post
export const CREATE_RISK_LEVEL_REQUEST = "CREATE_RISK_LEVEL_REQUEST";
export const CREATE_RISK_LEVEL_SUCCESS = "CREATE_RISK_LEVEL_SUCCESS";
export const CREATE_RISK_LEVEL_FAIL = "CREATE_RISK_LEVEL_FAIL";

// get
export const RISK_LEVEL_REQUEST = "RISK_LEVEL_REQUEST";
export const RISK_LEVEL_SUCCESS = "RISK_LEVEL_SUCCESS";
export const RISK_LEVEL_FAIL = "RISK_LEVEL_FAIL";

// find
export const FIND_RISK_LEVEL_REQUEST = "FIND_RISK_LEVEL_REQUEST";
export const FIND_RISK_LEVEL_SUCCESS = "FIND_RISK_LEVEL_SUCCESS";
export const FIND_RISK_LEVEL_FAIL = "FIND_RISK_LEVEL_FAIL";

// update/put
export const UPDATE_RISK_LEVEL_REQUEST = "UPDATE_RISK_LEVEL_REQUEST";
export const UPDATE_RISK_LEVEL_SUCCESS = "UPDATE_RISK_LEVEL_SUCCESS";
export const UPDATE_RISK_LEVEL_FAIL = "UPDATE_RISK_LEVEL_FAIL";

// update/put
export const DELETE_RISK_LEVEL_REQUEST = "DELETE_RISK_LEVEL_REQUEST";
export const DELETE_RISK_LEVEL_SUCCESS = "DELETE_RISK_LEVEL_SUCCESS";
export const DELETE_RISK_LEVEL_FAIL = "DELETE_RISK_LEVEL_FAIL";

export const CLEAR_ERROR = "CLEAR_ERROR";